import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '', // 基础URL，可通过环境变量配置
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage中获取token
    const token = localStorage.getItem('token')
    // 如果有token，添加到请求头
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 可以在这里添加其他请求头
    // config.headers['X-Requested-With'] = 'XMLHttpRequest'
    return config
  },
  error => {
    // 处理请求错误
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 处理成功响应
    const res = response.data
    // 可以根据后端返回的状态码进行处理
    // 例如：if (res.code !== 200) { ... }
    return res
  },
  error => {
    // 处理响应错误
    console.error('响应错误:', error)
    // 可以根据错误状态码进行处理
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权，跳转到登录页
          // router.push('/login')
          break
        case 403:
          // 禁止访问
          break
        case 404:
          // 资源不存在
          break
        case 500:
          // 服务器错误
          break
        default:
          // 其他错误
          break
      }
    }
    return Promise.reject(error)
  }
)

export default service
